import classNames from 'classnames';

import styles from './_index.module.scss';

export interface FieldsetProps extends React.FieldsetHTMLAttributes<HTMLFieldSetElement> {
  legend: React.ReactNode;
}

const Fieldset = ({ children, className, legend, ...props }: FieldsetProps) => {
  return (
    <fieldset className={classNames(styles['fieldset'], className)} {...props}>
      <legend className={styles['legend']}>{legend}</legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
